module.exports = __webpack_public_path__ + "img/Newbie_Sword_04_Warrior.ca5ec3cb.png";